import { type ReactElement } from 'react'

interface TooltipBoxProps {
  text: string | number
}

export function RedTooltipBox ({ text }: TooltipBoxProps): ReactElement {
  return (
    <div
      className="absolute -top-10 -left-10 rounded-full border border-gray-200 animate__animated animate__fadeIn bg-white z-100"
      style={{ animationDuration: '100ms' }}
    >
      <div style={{ maxWidth: '600px' }}>
        <div className="rounded-md px-6 pt-2 pb-3 bg-wpy-blue-gray-700 text-white">
          {text}
          <div
            className="absolute -bottom-2 right-8 w-4 h-4 bg-wpy-blue-gray-700 transform rotate-45"
            style={{
              marginLeft: '-0.5rem'
            }}
          />
        </div>
      </div>

    </div>
  )
}
